module.exports = __webpack_public_path__ + "assets/e5aa21dd28d2f7e256aabd080f6727ef.mp3";